import { FC, ReactNode, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Container, Stack, useMediaQuery, useTheme } from '@mui/material';
import { ProgressCloseButton } from 'components';
import { useSmoothTopScroll } from 'hooks';

import { AppModal } from '../AppModal';
import { Footer, Header } from '..';

export interface LayoutProps {
  children?: ReactNode;
}

export const Layout: FC<LayoutProps> = ({ children }) => {
  const { pathname } = useLocation();
  const firstPathAtPathname = useMemo(() => pathname.split('/')[1], [pathname]);
  useSmoothTopScroll(firstPathAtPathname);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Stack flexDirection="column" minHeight="100vh" overflow="hidden">
      <ToastContainer
        autoClose={4000}
        style={{ top: isMobile ? 64 : 80 }}
        hideProgressBar
        position="top-right"
        closeButton={<ProgressCloseButton />}
      />
      <Header />
      <AppModal />
      <Container
        sx={{
          flex: 1,
          my: {
            xs: 5,
            md: 10,
          },
          px: {
            xs: 1.25,
            sm: 1.25,
            md: 4,
            lg: 4,
            xl: 0,
          },
          position: 'relative',
          zIndex: 1,
          minHeight: '50vh',
        }}
      >
        {children}
      </Container>
      <Footer />
    </Stack>
  );
};
